import { Alert, Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

const FryerDetail = () => 
{
    const { id } = useParams();
    const navigate = useNavigate(); 
    const [fryer, setFryer]= useState({
        name: '',
        hersteller:'',
        offset_duration: '',
        offset_temp: ''
    });
    const [errorMessage, setErrorMessage] = useState(null);
    
    useEffect(() => {
        const requestOptions = {
            method: 'GET'
        };
        fetch('/api/fryer/'+id, requestOptions)
        .then(r => r.json())
        .then(j =>{
            setFryer(j);
        })
        .catch(err => console.error(err));
    }, [id]);

    const handleSubmit = async () =>{
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: JSON.stringify({
                'id': id,
                'hersteller': fryer?.hersteller
            })
        };
        const response = await fetch('/api/fryer', requestOptions);
        if(response.ok){
            navigate('/fryer', {state: {'message': 'Der Fryer wurde erfolgreich bearbeitet.'}});
        }else{
            const json = await response.json();
            setErrorMessage(json.message);
        }
    };

    return(
        <div className="centered">
            <Button sx={{marginLeft:'15px !important'}} fullWidth className="custom-button-root" onClick={evt => window.location.assign('/fryer')}>zurück</Button>            
            <h2>Fryer bearbeiten</h2>
            <TextField
               fullWidth
               label="Name"
               disabled
               value={fryer?.name}
            />
            <TextField
               fullWidth
               label="Hersteller"
               required
               onChange={(event) => setFryer({...fryer, hersteller: event.target.value})}
               value={fryer?.hersteller}
            />
            <TextField
               fullWidth
               value={fryer?.offset_temp}
               disabled
               label="Offset Temperature"
            />
            <TextField
               fullWidth
               value={fryer?.offset_duration}
               disabled
               label="Offset Dauer"
            />
            <Button sx={{marginLeft:'15px !important'}} fullWidth className="custom-button-root" onClick={() => handleSubmit()}>Speichern</Button>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        </div>
    );
}

export default FryerDetail;